import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CambioVisualeService {
  private cambioVisuale: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getCambioVisuale(): Observable<boolean> {
    return this.cambioVisuale.asObservable();
  }

  setCambioVisuale(value: boolean): void {
    this.cambioVisuale.next(value);
  }
}
